import { render, staticRenderFns } from "./custompartdescriptions.vue?vue&type=template&id=09ee63bc&lang=pug"
import script from "./custompartdescriptions.vue?vue&type=script&lang=js"
export * from "./custompartdescriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports